import React from "react";
import BusHeartMarkerImage from "../../assets/images/BusHeartMarker.png";

const BusHeartMarker = ({ size = 42 }) => {
  return (
    <img
      src={BusHeartMarkerImage}
      alt=""
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        display: "block",
        objectFit: "contain",
      }}
    />
  );
};

export default BusHeartMarker;
